import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegionPageComponent } from './pages/region-page/region-page.component';
import { FertilityHomePageComponent } from './pages/fertility-home-page/fertility-home-page.component';

const routes: Routes = [
  {
    path: '',
    component: FertilityHomePageComponent,
  },
  {
    path: 'region/:id',
    component: RegionPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FertilityDashboardRoutingModule {}
